import * as React from "react";
const SvgIcSidebar = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M1 21H23V3H1V21ZM8 18H4V6H8L8 18ZM11 18H20V6H11L11 18Z" fill="currentColor" /></svg>;
export default SvgIcSidebar;